var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticStyle:{"margin":"5px","text-transform":"none"},attrs:{"text":"","color":"primary","elevation":"10","rounded":"","x-large":""},on:{"click":function($event){return _vm.logout()}}},[_vm._v(" ausloggen ")])}
var staticRenderFns = []

export { render, staticRenderFns }